/*
    Due to "npm run start" will access backend api through api gateway,
    so we need to add "/aidp" to the api base url when not in dev environment
*/
const IS_LOCAL_DEV = process.env.REACT_APP_IS_DEV;
const API_BASE_URL = `${process.env.REACT_APP_APIGATEWAY_URL}${!IS_LOCAL_DEV ? '/aidp' : ''}`;
const IS_SERVER_DEV = process.env.REACT_APP_ENV === 'development';
const IS_PRODUCTION = process.env.REACT_APP_ENV === 'production';

const GRIST_BASE_URL = 'https://grist.rfdme.io';
const GRIST_PROJECT_DOC_ID = IS_PRODUCTION ? '5J7q9UpZAsYwG67P3RYFq6' : 'rJiAhxaAKfPjYZPEnTSxx6';
const GRAFANA_BASE_URL = 'https://grafana.in.aidp.rfdme.io';

module.exports = {
  IS_LOCAL_DEV,
  API_BASE_URL,
  IS_SERVER_DEV,
  IS_PRODUCTION,
  GRIST_BASE_URL,
  GRIST_PROJECT_DOC_ID,
  GRAFANA_BASE_URL
};